import { typeCreatorV2 } from 'redux/utils/common';

//  [REDUCER][TYPE]
export const SET_SPECIFICATIONATTRIBUTE_LIST: string = typeCreatorV2(
  'SpecificationAttributeEditReducer',
  'SetSpecificationAttributeList'
);

export const SET_ADD_SPECIFICATIONATTRIBUTE: string = typeCreatorV2(
  'SpecificationAttributeEditReducer',
  'SetAddSpecificationAttribute'
);

export const SET_EDIT_SPECIFICATIONATTRIBUTE: string = typeCreatorV2(
  'SpecificationAttributeEditReducer',
  'SetEditSpecificationAttribute'
);

export const SET_SPECIFICATIONATTRIBUTE_DETAIL: string = typeCreatorV2(
  'SpecificationAttributeEditReducer',
  'SetSpecificationAttributeDetail'
);

export const SET_SEGMENTS: string = typeCreatorV2(
  'SpecificationAttributeEditReducer',
  'SetSegments'
);

export const UPDATE_NAME_TEMPORARY: string = typeCreatorV2(
  'SpecificationAttributeEditReducer',
  'UpdateNameTemporary'
);

export const SET_LIST_ICON: string = typeCreatorV2(
  'SpecificationAttributeEditReducer',
  'SetListIcon'
);
